import { BuildingIcon, CaseIcon } from '../../../../../components/Icons'
import { Profile } from '../../../../../types/persona'

const DEFAULT_PROFILE_IMAGE = 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'

interface HeaderProps extends Partial<Profile> {
  isLoading?: boolean
}

export function Header({
  profileIdleLoop,
  firstName,
  lastName,
  headline,
  industry,
  jobTitle,
  location,
  connections,
  profilePictureUrl,
  isLoading,
}: HeaderProps) {
  return (
    <div className="flex items-center mb-8">
      <div className="h-20 w-20 rounded-full mr-4 ring-white bg-white overflow-hidden">
        <video
          className="h-full w-full object-cover"
          src={profileIdleLoop}
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
          onError={e => {
            const target = e.target as HTMLVideoElement
            target.style.display = 'none'
            const fallbackImg = target.parentElement?.querySelector('img')
            if (fallbackImg) {
              fallbackImg.style.display = 'block'
            }
          }}
        />
        <img
          src={profilePictureUrl || DEFAULT_PROFILE_IMAGE}
          alt={`${firstName} ${lastName}`}
          className="h-full w-full object-cover"
          style={{ display: profileIdleLoop ? 'none' : 'block' }}
          onError={e => {
            const target = e.target as HTMLImageElement
            target.src = DEFAULT_PROFILE_IMAGE
          }}
        />
      </div>
      {!isLoading && firstName && lastName ? (
        <div>
          <h1 className="text-2xl font-bold text-white">
            {firstName}
            {' '}
            {lastName}
          </h1>
          <p className="text-base text-white text-left">{headline}</p>

          {/* Meta Information */}
          <div className="mt-2 flex flex-wrap gap-4 text-sm text-white">
            <div className="flex items-center gap-1">
              <CaseIcon size={16} />
              {jobTitle}
            </div>
            <div className="flex items-center gap-1">
              <BuildingIcon size={16} />
              {industry}
            </div>
            <div className="flex items-center gap-1">
              <i className="fa-solid fa-location-dot text-sm" />
              {location}
            </div>
            <div className="flex items-center gap-1">
              <i className="fa-solid fa-users text-sm" />
              {connections}
              + connections
            </div>
          </div>
        </div>
      ) : (
        <div className="animate-pulse">
          <div className="h-5 bg-gray-200 rounded w-36 mb-2" />
          <div className="h-4 bg-gray-200 rounded w-48" />
        </div>
      )}
    </div>
  )
}
